import PropTypes from 'prop-types';
import React, { memo, useId } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';

import { TableFiles } from '../TableFiles';

import style from './style.module.css';

const FilesPanelComponent = ({ files, onUploadFile, onDeleteFile }) => {
  const id = `acc-slide-${useId()}`.replaceAll(':', '_');

  return (
    <div className={classNames(style.host, 'panel panel-default')}>
      <div className="panel-heading" data-parent="#accordion" data-target={`#${id}`} data-toggle="collapse">
        <h4 className="panel-title">Files</h4>
      </div>
      <div className="panel-collapse collapse" id={id}>
        <div className="panel-body">
          <div onSubmit={onUploadFile}>
            <TableFiles files={files} onDeleteFile={onDeleteFile} onUploadFile={onUploadFile} />
          </div>
        </div>
      </div>
    </div>
  );
};

FilesPanelComponent.propTypes = {
  files: PropTypes.instanceOf(List).isRequired,
  onUploadFile: PropTypes.func.isRequired,
};

/** Files panel component. */
export const FilesPanel = memo(FilesPanelComponent);
